import React from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { emptyValue } from "utils/emptyValue";
import { formatAmount, formatDateTime } from "utils/localizations";
import Section from "views/common/section";
import type PaymentCardGatewayDetailViewModel from "viewModels/finance/payments/cardGateWay/paymentCardGatewayDetailViewModel";

export interface BaseInfoProps {
  vm: PaymentCardGatewayDetailViewModel;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
const BaseInfo = observer((props: BaseInfoProps) => {
  const { vm } = props;

  return (
    <Section title={vm.translate("baseInfoTitle")} context>
      <Form.Row>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("authorizedAt")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="authorizedAt"
            valueFormatter={value => (value ? formatDateTime(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("transactionType")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="transactionType"
            valueFormatter={value => (value ? vm.translate(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("bruttoAmount")}</Form.Label>
          <FakeInput
            className={`text-${vm.isAmountPositive ? "success" : "danger"}`}
            target={vm.item}
            property="bruttoAmount"
            valueFormatter={value => (value ? <strong>{formatAmount(value)}</strong> : emptyValue)}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("interchangeFee")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="interchangeFee"
            valueFormatter={value => (value ? formatAmount(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("acquirerFee")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="acquirerFee"
            valueFormatter={value => (value ? formatAmount(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("commissionFee")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="commissionFee"
            valueFormatter={value => (value ? formatAmount(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("nettoAmount")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="nettoAmount"
            valueFormatter={value => (value ? formatAmount(value) : emptyValue)}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translate("paymentClassification")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="paymentClassification"
            valueFormatter={value => vm.translatePaymentTemplate(value) ?? emptyValue}
          />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default BaseInfo;
